<div class="container-fluid" style="background-color: #f1f1f3;">
    <!-- Header -->
    <div class="col-md-12 col-lg-12 col-12 padLeft25 webView" style="padding: 15px; padding-bottom: 0px;">
        <!-- title -->
        <div class="col-md-7 col-lg-7 col-12" style="display: inline-block; padding: 0px;">
            <div class="col-md-10 col-lg-10 col-12 lblHeader newHeader" style="padding: 0px; display: inline-block;">
                <h4 style="display: inline-block; font-size: 25px;">Production Entry</h4>
            </div>
        </div>
        <div class="col-md-5 col-lg-5 col-3 webView" style="display: inline-block; text-align: right; padding: 0px; ">
            <span class="darkBlueButton font13" style="display: inline-block; font-size: 14px;" (click)="backBtn()">
                <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Inventory
            </span>
        </div>
    </div>
    <div class="col-md-12 col-lg-12 col-12 mobView" style="padding: 20px 0px 10px 0px;">
        <!-- title -->
        <div class="col-md-7 col-lg-7 col-12" style="display: inline-block; padding: 0px;">
            <div class="col-md-10 col-lg-10 col-12" style="padding: 0px; display: inline-block;">
                <h4 class="newHeader" style="display: inline-block;">Production Entry</h4>
                <span class="btn darkBlueButton" style="float: right;" (click)="backBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </div>
        </div>
    </div>


    <div class="col-md-12 col-lg-12 col-12" style="display: flex; padding: 0px;">
        <div class="col-md-12 col-lg-12 col-12 padLeft5" style="padding: 0px; display: inline-block;">
            <div class="com-md-12 col-lg-12 col-12" style="padding: 0px;">
                <div class="col-md-12 col-lg-12 col-12 padhedrbtnLeft5" style="padding-bottom: 0px; display: inline-block;">
                    <div class="orgWEditBtn font13 brdrRadius3" style="margin-right: 10px; cursor: pointer;" (click)="selectStore(selection)"
                    title="Select Store">
                        <div class="cl">
                            <i class="zmdi zmdi-city-alt" style="margin-right: 5px;"></i>
                            <span *ngIf="frmStore.name">Store </span>
                            <span style="font-weight: bold; padding-left: 5px;">{{frmStore.name ? frmStore.name : 'Select Store'}}</span>
                        </div>
                        <div class="cr">
                            <i class="fa fa-pencil"></i>
                        </div>
                    </div>
                    
                    <div class="drkGreenBadge-wb"
                        style="display: inline-block; margin-top: 10px; margin-right: 10px; position: relative; padding: 3px 10px; font-size: 13px; height: 30px;">
                        <div class="col-md-12" style="padding: 0px;">
                            <div class="{{ isShowPrevNo ? 'col-md-7' : 'col-md-12' }}"
                                style="display: inline-block; padding: 0px;">
                                <i class="zmdi zmdi-file-text" style="margin-right: 5px;"></i>
                                <span style="display: inline-block;">Ref No.</span>
                                <span>
                                    <input type="text" class="form-control" [(ngModel)]="xnCode"
                                        style="background-color: inherit !important; height: 20px; padding: 2px; display: inline-block; margin-left: 10px; width: 50%;">
                                </span>
                            </div>
                            <div *ngIf="isShowPrevNo" class="col-md-5"
                                style="display: inline-block; padding: 0px; width: fit-content;">
                                <span style="color: #777; font-size: 12px; margin-left: 5px;">(Prev:
                                    {{prevXnCode}})</span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <!-- production - mobile view -->
            <div class="col-md-12 col-lg-12 col-12 mobView" *ngIf="items.length > 0" style="margin: 0px; margin-top: 10px;padding: 0px; margin-bottom: 10px; margin-top: 25px; margin-bottom: 20px;box-shadow: 1px 1px 6px 1px rgb(0 0 0 / 8%);">
                <div class="col-md-12 col-lg-12 col-12"  style="background-color: #fff; padding: 15px 10px 20px 10px;">
                    <div style="display: inline-block; font-size: 19px; font-weight: 600;"> Production</div>
                    <div style="display: inline-block; float: right;"> 
                        <div class="label darkBlueBadge-wb {{isGenEdit ? 'darkBlueBadge-wb-active' : ''}} brdrRadius3 font13" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer;"
                        (click)="editGenItems()">
                            <i class="fa fa-pencil font13" style="margin-right: 5px;" aria-hidden="true"></i> Change
                        </div>
                        <div class="orangeBadge-wb font13" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer;" (click)="openItemSelect(selectItem)"
                        title="Add More Items">
                            <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i> Add
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-12" *ngFor="let i of items; let l = last; let in = index;"
                    style="background: #FFF; padding: 10px; border-top: 2px solid #F8F8F8; {{ l ? 'border-bottom: 2px solid #F8F8F8;' : '' }} font-size: 13px;">
                    <div class="col-md-6 col-lg-6 col-6"
                        style="padding: 0px; display: inline-block; color: #444; font-weight: bold;">
                        {{i.itemName}}
                    </div>
                    <div class="col-md-6 col-lg-6 col-6"style="padding: 0px; display: inline-block; text-align: right;">
                        <span *ngIf="isGenEdit" style="width: 50%; display: inline-block;">
                            <input class="form-control bzInput bzInputPad" type="text"
                                placeholder="Qty" style="text-align: right;font-size: 13px;width: 95%;" [(ngModel)]="i.issueQty"
                                (change)="getTransferQty(i)" (keyup)="prcisionCheck(i)">
                        </span>
                         <span *ngIf="!isGenEdit"class="">
                            {{i.issueQty}}
                        </span>
                        <span style="padding-left: 3px;">{{i.sku}}</span>
                        
                        <span *ngIf="isGenEdit" style="margin-left: 5px; background: #1111110A; padding: 3px 6px; border-radius: 3px;"
                            (click)=deleteItem()>
                            <i class="fa fa-times" style="color: #777;"></i>
                        </span>
                       
                    </div>
                    <!-- <div style="text-align: right;"> <span style="margin-right: {{!isGenEdit ? '0px' : '25px'}}"> {{i.sku}}</span></div> -->
                    <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; display: inline-block;">
                        <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px; padding: 3px 10px; font-size: 12px;">Total Qty <span style="font-weight: bold;">{{i.stkQty}}</span>
                        </div>
                        <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px; padding: 3px 10px; font-size: 12px;">Store Qty <span style="font-weight: bold;">{{i.strQty}}</span>
                        </div>
                        <div *ngIf="i.hasBatches" (click)="isGenEdit ? openBatchSelectionMdl(i) : '' " class="lableBtnOrange brdrRadius3 font13"
                            style="display: inline-block;padding: 4px 12px; margin-top: 7px; float: right; font-size: 12px !important;"><i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                        </div>
                        <!-- <div class="blueBadgeNew font13"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px;">Produced Qty {{i.DoneQty}}</div> -->
                    </div>
                </div>
            </div>

            <!-- production - web view -->
            <div class="row webView" style="margin: 0px;" *ngIf="items.length > 0">
                <div class="col-md-12 col-lg-12 col-12" style="margin-top: 15px;" >
                    <div class="col-md-8 col-sm-8 col-xs-8 " style="padding: 0px;padding-left: 3px">
                        <div style="display: inline-block; font-size: 18px;"> Production</div>
                        <div style="display: inline-block; float: right;"> 
                            <div class="label darkBlueBadge-wb {{isGenEdit ? 'darkBlueBadge-wb-active' : ''}} brdrRadius3 font13" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer; line-height: 18px; vertical-align: top;"
                            (click)="editGenItems()">
                                <i class="fa fa-pencil font13" style="margin-right: 5px;" aria-hidden="true"></i> Change
                            </div>
                            <div class="orangeBadge-wb font13" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer; line-height: 18px;" (click)="openItemSelect(selectItem)"
                            title="Add More Items">
                                <i class="zmdi zmdi-plus" aria-hidden="true" style="margin-right: 5px;"></i> Add
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-8 col-xs-8" style="padding: 0px;">
                        <table class="table table-borderd ngTable bzMatTbl shadow brdrRadius3"
                        style="margin-bottom: 10px;  background-color: white;" >
                        <thead style="font-size: 13px; cursor: pointer;">
                            <tr>
                                <th style="width: 200px; padding-left: 10px; border-top: none;">Product</th>
                                <th style="width: 90px;  text-align: right; border-top: none;">Total Qty</th>
                                <th style="width: 100px; text-align: right; border-top: none;">Store Qty </th>
                                <th style="width: 130px; padding-right: 25px; text-align: right; border-top: none;">Produced Qty</th>
                                <th style="width: 65px; border-top: none;">Unit</th>
                                <th style="width: 100px; border-top: none;"*ngIf="batchCnt > 0"></th>
                                <th style="width: 65px; border-top: none;"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let i of items; let l = last; let in = index;" style="vertical-align: middle;cursor: pointer; ">
                                <td style="padding-left: 10px; vertical-align: middle;">{{i.itemName}}</td>
                                <td class="itemTblTr">{{i.stkQty}}</td>
                                <td class="itemTblTr">{{i.strQty}}</td>
                                <td class="itemTblTr" style="padding-right: 25px;">
                                    <span *ngIf="isGenEdit" class="prdQtyTxtBox">
                                        <input class="form-control bzInput bzInputPad" type="text"
                                            style="text-align: right;" [(ngModel)]="i.issueQty"
                                            (change)="getTransferQty(i)" (keyup)="prcisionCheck(i)">
                                    </span>
                                    <span *ngIf="!isGenEdit"class="prdQtyTxtBox">
                                        {{i.issueQty}}
                                    </span>
                                </td>
                                <td style="vertical-align: middle;"><span>{{i.sku}}</span></td>
                                <td style="padding-left: 15px; font-size: 12px; vertical-align: inherit;" *ngIf="batchCnt > 0">
                                    <div *ngIf="i.hasBatches" class="lableBtnOrange brdrRadius3 inLneBlk" style="border-radius: 30px; padding: 3px 10px 3px; cursor : {{isGenEdit ? 'pointer' : 'no-drop'}};" (click)="isGenEdit ? openBatchSelectionMdl(i) : '' ">
                                        <i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                                    </div>
                                </td>  
                                <td style="vertical-align: middle; text-align: right; padding-right: 10px !important;">
                                    <span *ngIf="isGenEdit" class="lableBtnGray brdrRadius3" (click)="deleteItem(in)"  title="Delete" style="border-radius: 10px; vertical-align: middle; cursor: pointer;">
                                        <i class="fa fa-trash"></i></span>
                                </td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div *ngIf="items.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 15px;">
                <div class="nrf" style="cursor: pointer;" (click)="openItemSelect(0)">Please select item for production.</div>
            </div>

            <!-- save & update, cancel button -->
            <div *ngIf="items.length > 0" class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px;">
                <div *ngIf="isGenEdit || bomData.length > 0" class="btn-darkGreen font13 marginleftsgrnBtn" style="margin-top: 10px; padding: 0px 10px; border-radius: 3px; line-height: 30px;
                margin-left: 13px; cursor: pointer;" (click)="proposeQty();">
                    <i class="fa fa-check" style="margin-right: 5px; font-size: 13px;" aria-hidden="true"></i> {{ isGenEdit ?'Save & Update Consumption' :  'Calculate Consumption'}}
                </div>
                <div *ngIf="isGenEdit" class="darkBlueButton font13 marginleftsgrnBtn" style="margin-top: 10px; border-radius: 10px; line-height: 30px; padding:0px 10px !important; margin-left: 10px !important; cursor: pointer;"
                (click)="resetData();">
                    <i class="fa fa-trash" style="margin-right: 5px; font-size: 13px;" aria-hidden="true"></i> Cancel
                </div>
            </div>



             <!-- material consumption - mobile view -->
            <div class="col-md-12 col-lg-12 col-12 mobView" *ngIf="isShowBOM && items.length > 0" style="margin: 0px; padding: 0px; margin-top: 25px !important; margin-bottom: 75px; box-shadow: 1px 1px 6px 1px rgb(0 0 0 / 8%);">
                <div class="col-md-12 col-lg-12 col-12" style="background-color: #fff; padding: 15px 10px 20px 10px;">
                    <div style="display: inline-block; font-size: 19px; font-weight: 600;"> Material Consumption</div>
                    <div  *ngIf="!isGenEdit" style="display: inline-block; float: right;"> 
                        <div style="display: inline-block;float: right;"> 
                            <div class="label darkBlueBadge-wb font13" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer;"
                            (click)="openMtlSelect(selectItem)">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px; font-size: 13px;" aria-hidden="true"></i> Select  
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="bomData.length > 0">
                    <div class="col-md-12 col-lg-12 col-12"  *ngFor="let i of bomData; let l = last; let in = index;" style="background: #FFF; padding: 10px; border-top: 2px solid #F8F8F8; {{ l ? 'border-bottom: 2px solid #F8F8F8;' : '' }} font-size: 13px; border-bottom: 5px solid #f1f3f8">
                    <div class="col-md-6 col-lg-6 col-6"
                        style="padding: 0px; display: inline-block; color: #444; font-weight: bold;">
                        {{i.bomItemName}}
                    </div>
                    <div class="col-md-6 col-lg-6 col-6"
                        style="padding: 0px; display: inline-block; text-align: right;">
                        <span *ngIf="!isGenEdit" style="width: 50%; display: inline-block;">
                            <input class="form-control bzInput bzInputPad" type="text"
                                placeholder="Qty" style="text-align: right;font-size: 13px;width: 95%;" [(ngModel)]="i.mtlQty"
                                (change)="getUsedQty(i)" (keyup)="prcisionCheck(i)"></span>
                        <span *ngIf="isGenEdit"class="prdQtyTxtBox">
                            {{i.mtlQty}}
                        </span>
                        <span> {{i.unit}}</span>
                        <span *ngIf="!isGenEdit" style="margin-left: 5px; background: #1111110A; padding: 3px 6px; border-radius: 50%;"
                        (click)="deleteBOMItems(in)">
                            <i class="fa fa-times" style="color: #777;"></i>
                        </span>
                     
                    </div>
                    <!-- <div style="text-align: right;"> <span style="{{!isGenEdit ? 'margin-right: 25px' : '0px'}};"> {{i.unit}}</span></div> -->

                    <div class="col-md-12 col-lg-12 col-12" style="padding: 0px; display: inline-block;">
                        <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px; font-size: 12px; padding: 3px 10px;">Total Qty <span style="font-weight: bold;">{{i.stkQty}}</span>
                        </div>
                        <div class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite"
                            style="display: inline-block; margin-right: 10px; margin-top: 10px; font-size: 12px; padding: 3px 10px;">Store Qty <span style="font-weight: bold;">{{i.storeItemQty}}</span>
                        </div>
                        <div *ngIf="i.hasBatches" (click)="!isGenEdit ? openBatchSelectionMdl(i) : '' " class="lableBtnOrange brdrRadius3 font13"
                        style="display: inline-block; padding: 4px 12px; float: right; margin-top: 10px; font-size: 12px !important;"> <i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right: 5px;"></i>Batches
                        </div>
                    </div>
                </div>
               
                </div>
                <div *ngIf="bomData.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; margin-top: 15px;">
                    <div class="nrf" style="cursor: pointer;">No bom data found.</div>
                </div>
                
            </div>

            <!-- material consumption - web view -->
            <div class="row webView" style="margin: 0px; margin-top: 20px;" *ngIf="isShowBOM">
                <div class="col-md-12 col-lg-12 col-12" style="padding: 0px;" *ngIf="bomData.length > 0">
                    <div class="col-md-8 col-sm-8 col-xs-8" style="padding-right: 0px;"> 
                        <div style="display: inline-block; font-size: 18px;padding-left: 2px;">Material Consumption</div>
                        <div *ngIf="!isGenEdit" style="display: inline-block; float: right; padding-right: 5px;"> 
                            <div class="label darkBlueBadge-wb font13 brdrRadius3" style="margin-bottom: 10px; margin-left: 10px; cursor: pointer; line-height: 18px;"
                            (click)="openMtlSelect(selectItem)">
                                <i class="zmdi zmdi-plus" style="margin-right: 5px; font-size: 13px;" aria-hidden="true"></i> Select  
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8 col-lg-8 col-8" style="margin-top: 0px;padding-right: 2px;" *ngIf="bomData.length > 0">
                        <table class="table table-borderd ngTable bzMatTbl shadow brdrRadius3"
                            style="margin-bottom: 10px;  background-color: white;" >
                            <thead style="font-size: 13px; cursor: pointer;">
                                <tr>
                                    <th style="width: 200px; padding-left: 10px;border-top: none;">Material</th>
                                    <th style="width: 90px; text-align: right; border-top: none;">Total Qty</th>
                                    <th style="width: 130px; padding-right: 25px; text-align: right; border-top: none;">Store Qty</th>  
                                    <th style="width: 130px; padding-right: 25px; text-align: right; border-top: none;">Used Qty</th>
                                    <th style="width: 65px; border-top: none;">Unit</th>
                                    <th style="width: 100px; border-top: none;"*ngIf="batchCnt > 0"></th>
                                    <th style="width: 65px; border-top: none;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let i of bomData; let l = last; let in = index;" style="vertical-align: middle;cursor: pointer; ">
                                    <td style="padding-left: 10px; vertical-align: middle;">{{i.bomItemName}}</td>
                                    <td class="itemTblTr">{{i.stkQty}}</td>
                                    <td class="itemTblTr">{{i.storeItemQty}}</td>
                                    <!-- <td class="itemTblTr">{{i.PlanQty}}</td> -->
                                    <td  class="itemTblTr" style="padding-right: 25px;">
                                        <span *ngIf="!isGenEdit" class="prdQtyTxtBox">
                                            <input class="form-control bzInput bzInputPad" type="text"
                                                style="text-align: right;  background: inherit; padding-top: 8px;" [(ngModel)]="i.mtlQty"
                                                (change)="getUsedQty(i)" (keyup)="prcisionCheck(i)">
                                        </span>
                                        <span *ngIf="isGenEdit"class="prdQtyTxtBox">
                                        {{i.mtlQty}}
                                        </span>
                                    </td>
                                     <td style="vertical-align: middle;"><span>{{i.unit}}</span></td>
                                     <td style="padding-left: 15px;font-size: 12px; vertical-align: middle;" *ngIf="batchCnt > 0">
                                        <div *ngIf="i.hasBatches" class="lableBtnOrange inLneBlk" style="border-radius: 3px; padding: 3px 10px 3px; cursor: {{!isGenEdit ? 'pointer' : 'no-drop'}};" (click)="!isGenEdit ? openBatchSelectionMdl(i) : '' ">
                                            <i class="{{i.Batches.length > 0 ? 'fa fa-pencil' : 'zmdi zmdi-plus' }}" style="margin-right:5px;"></i>Batches
                                        </div>
                                    </td>   
                                     <td style="vertical-align: middle; text-align: right; padding-right: 10px !important;">
                                        <span *ngIf="!isGenEdit" class="lableBtnGray" (click)="deleteBOMItems(in)"  title="Delete" style="border-radius: 10px; vertical-align: middle; cursor: pointer;">
                                            <i class="fa fa-trash"></i></span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div *ngIf="bomData.length == 0" class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px; ">
                    <div class="nrf" style="cursor: pointer; padding: 7px 15px;">No bom data found.</div>
                </div>
            </div>

            <div *ngIf="bomData.length > 0" class="webView" style="width: 100%; text-align: left; padding-left: 17px;">
                <div style="margin-top: 20px; margin-bottom: 15px;">
                    <div class="darkBlueButton font13" style="padding: 0px 10px; font-size: 14px;  border-radius: 3px; line-height: 18px; cursor:{{!isGenEdit ? 'pointer' : 'no-drop'}};"  (click)="!isGenEdit ? fn_savePrdEnty() : '' "><i class="fa fa-check"
                            aria-hidden="true" style="margin-right: 5px;"></i> Save Production Entry </div>
                </div>
            </div>

            <div class="mobView2" *ngIf="bomData.length > 0"  >
                <div class="mrgLeft220" style="position: fixed; width: 100%; left: 0px !important; bottom: 0px; text-align: center; background-color: #FFF; padding-bottom: 10px;">
                    <div style="margin-top: 10px;">
                        <div class="darkBlueButton font13" style="padding: 0px 10px; font-size: 14px; line-height: 18px; border-radius: 10px;" (click)="!isGenEdit ? fn_savePrdEnty() : '' ">
                                <i  class="fa fa-check" aria-hidden="true"></i> Save Production Entry
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<!-- Item Modal -->
<ng-template #selectItem let-modal>
    <app-multiple-select-item></app-multiple-select-item>
</ng-template>

<!-- Store Selection Modal -->
<!-- <ng-template #storeSelect let-modal>
    <app-select-store></app-select-store>
</ng-template> -->
<!-- <button id="openModal" (click)="openModal(selection)" hidden="true"></button> -->

<!-- Store Selection Modal -->
<ng-template #selection let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
            <h4 class="modal-title"><span id="ApntmntHdr" style="font-size: 22px;">Select Store</span></h4>
            </div>
            <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
            <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()"></i>
            </div>
        </div>
        </div> 
    </div>
    <!--Body-->
    <div class="modal-body" style="padding-top: 0px;">
        <div class="col-md-12 col-sm-12 col-12" style="padding: 0px;">
        <div class="col-md-12 col-sm-12 col-xs-12" style="display: inline-block; padding: 0px;">
            <select class="label Bluebadge form-control bzInput" [(ngModel)]="frmStore.id" style="display: inline-block; font-size: 13px; cursor: pointer; padding: 5px;">
                <!-- <option value="0" selected >All</option> -->
                <!-- <option *ngFor="let s of stores" [ngValue]="s.StrID">{{s.sNm}}</option>   -->
                <option value="0" selected *ngIf="allStoreCnt == storeDataList.length">All</option>
                <option *ngFor="let s of storeDataList" [ngValue]="s.StrID">{{s.sNm}}</option>  
            </select>
        </div>
        </div>
    </div>
    <!--Footer-->
    <div class="" style="padding: 15px; border: none; text-align: left; float: left; padding-top: 0px;">
        <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px; line-height: 30px; font-size: 14px;" (click)="save()"
        title="Add more items for consumption">
            <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
            <span>Select</span>
        </span>
    </div>

</ng-template>
<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">
</ngx-spinner>
